module.exports = __webpack_public_path__ + "./assets/flags/germany.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ger@2x.png
// module id = 69
// module chunks = 0 1